<template>
  <div v-if="list && list.length > 0" class="p-t-20">
    <div v-if="list && list.length > 0" class="home-three-title">
      <div class="text fourth-text">
        <img class="fourth-img" src="https://staticfile.xlcwx.com/m-images/yth/lzjxy/img/homeFourth/open.png">
        <div class="text-slot">
          <slot>精品课程</slot>
        </div>
      </div>
      <span class="more" @click="zhibokes">查看更多&nbsp;></span>
    </div>

    <div v-if="list && list.length > 0" class="live">
      <div v-for="(item, index) in list" :key="index" class="item" @click="goPage(item)">
        <div class="content">
          <img class="item-img" :src="item.surfacePlot">
          <div class="detail">
            <div class="detail-title twoEllipsis">{{ item.courseName }}</div>
            <div class="item-tips elp">{{ item.belongCollegeName }} · {{ item.belongProjectName }}</div>
          </div>
        </div>
        <div class="flex-between-c price-box">
          <div class="price"><span class="price-icon">￥</span>{{ item.currentPrice }}</div>
          <div class="tips">人气值 {{ item.browseFrequency ? item.browseFrequency : 0 }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
 
import { HomeClient } from "@/api/home";
const homeClient = new HomeClient();
export default {
  components: {},
  data() {
    return {
      list: [] 
    }
  },
  created() {
    homeClient.qbsJxyCourse({pageNum: 1, pageSize: 6}).then((res) => {
      this.list = res.data.rows
    })
  },
  methods: {
    zhibokes() {
      const routeUrl = this.$router.resolve({
        path: '/jingpin/courer'
      })
      window.open(routeUrl.href, '_blank')
    },
    goPage(item) {
      if (!item) {
        return
      }
      if (item.teachingMethod == 1) {
        const routeUrl = this.$router.resolve({
          path: `/zhiboclassxq?id=${item.id}`
        })
        window.open(routeUrl.href, '_blank')
      } else if (item.teachingMethod == 2) {
        const routeUrl = this.$router.resolve({
          path: `/videoxq?id=${item.id}`
        })
        window.open(routeUrl.href, '_blank')
      }  
    }
  }
}
</script>
<style lang="less" scoped>
.home-three-title {
  padding-bottom: 30px;
  width: 1220px !important;
}

.live {
  width: 1220px;
  margin: auto;
  height: 348px;
  background: #ffffff;
  border-radius: 8px 8px 8px 8px;
  opacity: 1;
  display: flex;
  flex-wrap: wrap;
  padding: 20px;
  justify-content: space-between;
  margin-bottom: 60px;

  .item {
    width: 380px;
    height: 144px;
    background: linear-gradient(180deg, #fffcf1 0%, #fffdf8 100%);
    border-radius: 8px 8px 8px 8px;
    opacity: 1;
    margin-bottom: 20px;
    padding: 20px 16px 16px;

    .content {
      display: flex;

      .item-img {
        margin-top: 5px;
        width: 112px;
        height: 63px;
        border-radius: 8px 8px 8px 8px;
        opacity: 1;

        flex-shrink: 0;
        margin-right: 12px;
      }

      .detail {
        padding: 4px 0px 0px;

        .detail-title {
          height: 44px;
          font-size: 14px;
          font-family: Microsoft YaHei-Regular, Microsoft YaHei;
          font-weight: 400;
          color: #333333;
          line-height: 22px;
        }

        .item-tips {
          height: 12px;
          font-size: 12px;
          font-family: Microsoft YaHei-Regular, Microsoft YaHei;
          font-weight: 400;
          color: #ff7b1c;
          line-height: 12px;
          margin-top: 8px;
        }
      }
    }

    .tips {
      height: 12px;
      font-size: 12px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #999999;
      line-height: 12px;
    }

    .price-box {
      margin-top: 16px;

      .price {
        font-size: 18px;
        font-family: Microsoft YaHei-Regular, Microsoft YaHei;
        font-weight: Bold;
        color: #ff5e51;
        line-height: 18px;

        .price-icon {
          font-weight: 400;
        }
      }
    }
  }
}
</style>
